import BrandMonthlyReport from './BrandMonthlyReport';

// Wunder · adidas FW26 raporu. Rapor Ağustos'tan başlıyor (Temmuz kapsam dışı);
// Y-3 kampanyaları ayrı marka sayılıyor, dahil değil.
const CONFIG = {
  title: 'adidas · FW26 Kampanya Raporu',
  campaignLike: 'adidas',
  ikasBrand: 'adidas',
  brandLabel: 'adidas',
  logo: '/Adidas_logo.png',
  minDate: new Date(2026, 7, 1),
  campaignNote: 'adidas kampanyaları (Y-3 hariç)',
  presets: [
    { label: 'Ağu–Eyl', start: () => new Date(2026, 7, 1), end: () => new Date(2026, 8, 30) },
    { label: 'Ağustos', start: () => new Date(2026, 7, 1), end: () => new Date(2026, 7, 31) },
    { label: 'Eylül', start: () => new Date(2026, 8, 1), end: () => new Date(2026, 8, 30) },
    { label: 'Ekim', start: () => new Date(2026, 9, 1), end: () => new Date() },
  ],
};

export default function AdidasCampaignReport() {
  return <BrandMonthlyReport config={CONFIG} />;
}
